import {Component, inject, OnInit} from '@angular/core';
import {GridEventOutput, GridModel} from 'src/app/shared/model/page-grid';
import {SearchTramsInvoiceResponse} from '../../model/search-trams-invoice-response';
import {TramsInvoiceGridService} from '../../service/trams-invoice-grid.service';
import {TramsInvoiceModel} from '../../model/trams-invoice-model';
import {DatePipe} from '@angular/common';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-trams-invoices',
    templateUrl: './trams-invoices.component.html',
    standalone: false
})
export class TramsInvoicesComponent implements OnInit {
  private readonly datePipe = inject(DatePipe);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  protected readonly tramsInvoiceGrid: GridModel<SearchTramsInvoiceResponse> = {
    gridDataTestId: 'trams-invoices',
    gridTitle: 'TRAMS Invoices',
    replayButton: true,
    singleColumnFilter: false,
    columns: [
      {
        columnProperty: 'id',
        columnHeader: 'Invoice Id',
        sort: true,
        columnPropertyFunction: (item: TramsInvoiceModel) => `${item.invoiceId}`,
        clickable: true,
      },
      {
        columnProperty: 'tramsCentralDocumentId',
        columnHeader: 'Central Document ID',
        sort: true,
      },
      {
        columnProperty: 'tramsInvoiceNumber',
        columnHeader: 'Invoice Number',
        sort: true,
      },
      {
        columnProperty: 'recordLocator',
        columnHeader: 'Record Locator',
        sort: true,
      },
      {
        columnProperty: 'issueDate',
        columnHeader: 'Issue Date',
        sort: true,
        processData: (item) => this.datePipe.transform(item, 'M/d/yyyy') || '',
      },
      {
        columnProperty: 'dateCreated',
        columnHeader: 'Date Created',
        sort: true,
        processData: (item) => this.datePipe.transform(item, 'M/d/yyyy') || '',
      },
      {
        columnProperty: 'InvoiceTypeCode',
        columnHeader: 'Type Code',
        columnPropertyFunction: (item: TramsInvoiceModel) => item.invoiceTypeCodeName,
        sort: true,
      },
      {
        columnProperty: 'Client.ProfileName',
        columnHeader: 'Client Name',
        columnPropertyFunction: (item: TramsInvoiceModel) => item.clientName,
        sort: true,
      },
      {
        columnProperty: 'dataSourceId',
        columnHeader: 'Data Source ID',
        sort: true,
      },

    ],
    filters: [
      {
        filterProperty: 'tramsInvoiceNo',
        filterDisplayName: 'Invoice Number',
        filterType: 'AUTOCOMPLETE',
        config: {
          autocompleteTableName: 'Invoice',
          autocompleteColumnName: 'TramsInvoiceNumber',
          autocompleteEmitText: true,
        }
      },
      {
        filterProperty: 'invoiceRecordLocator',
        filterDisplayName: 'Invoice Record Locator',
        filterType: 'AUTOCOMPLETE',
        config: {
          autocompleteTableName: 'Invoice',
          autocompleteColumnName: 'RecordLocator',
          autocompleteEmitText: true,
        }
      },
      {
        filterProperty: 'issueStartDate',
        lastFilterProperty: 'issueEndDate',
        filterDisplayName: 'Issue Date',
        filterType: 'DATERANGE',
      },
      {
        filterProperty: 'createdStartDate',
        lastFilterProperty: 'createdEndDate',
        filterDisplayName: 'Created Date',
        filterType: 'DATERANGE',
      },
    ],
    gridGetService: inject(TramsInvoiceGridService),
    filtersInitial: {
      invoiceRecordLocator: this.route.snapshot.queryParamMap.get('invoiceRecordLocator'),
    }
  };

  public ngOnInit(): void {
    const url = window.location.href;
    if (!url.includes('?')) return;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      replaceUrl: true
    });
  }

  openInvoiceTab(item: GridEventOutput<TramsInvoiceModel>): void {
    window.open(`${item.item.linkForInvoiceDetails}`, "_blank");
  }
}
